import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/formatters';
import { useTranslatedName } from '../PostCards/useTranslatedName';

/**
 * Single watchlist row. Extracted from WatchlistPage so the title can use the
 * `useTranslatedName` hook (cards show an auto-translated title, no toggle),
 * which cannot be called inside the parent's `.map()`.
 */
function WatchlistCard({ product, alertPrice, onView, onRemove }) {
  const { t } = useTranslation();
  const name = useTranslatedName(product);
  const currentPrice = Number(product?.price) || 0;

  return (
    <div className="watchlistCard">
      <img
        src={product?.images?.[0] || product?.url || ''}
        alt=""
        className="watchlistCardImage"
      />
      <div className="watchlistCardInfo">
        <p className="watchlistCardTitle">{name}</p>
        <p className="watchlistCardPrices">
          {t('watchlist.currentPrice')}: {formatPrice(currentPrice, product)}
          {alertPrice > 0 &&
            ` · ${t('watchlist.alertAt')}: ${formatPrice(alertPrice, product)}`}
        </p>
        <div className="watchlistCardActions">
          <button type="button" onClick={onView}>
            {t('watchlist.viewAd')}
          </button>
          <button type="button" onClick={onRemove}>
            {t('watchlist.remove')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WatchlistCard;
